import TruncatedListSection from './TruncatedListSection';

export default TruncatedListSection;
